import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Assets/Styles/AboutUs/MeetTeam.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
import useWindowDimensions from "./windowDiamension";
import {
  getAboutUsTeamParagraphByPartner,
  getAboutUsTeamSectionByPartner,
} from "../../api/axios";
import useSWR from "swr";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import styled from "styled-components";

const ImgSrc = styled.img`
     display: block;
    width: 180px;
    height: 180px;
    z-index: 10;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    border: 4px solid white;
    margin: 10px auto;
}
`;

const ImgComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease-out;
  // background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 25px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 250px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
    margin: 10px;

  &:hover {
    margin: 10px;
      box-shadow: 0px 2px 6px #9E9E9E;
    background: linear-gradient(135deg, #ffffff 0%, #f0f2f5 100%);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${props => props.theme?.palette?.primary?.main || '#FF8533'}, ${props => props.theme?.palette?.secondary?.main || '#008FD3'});
    border-radius: 20px 20px 0 0;
  }

  @media (max-width: 1200px) {
    width: 260px;
    padding: 22px;
  }

  @media (max-width: 1024px) {
    width: 240px;
    padding: 20px;
  }

  @media (max-width: 768px) {
    width: 220px;
    padding: 18px;
  }

  @media (max-width: 480px) {
    width: 200px;
    padding: 15px;
  }

  @media (max-width: 360px) {
    width: 180px;
    padding: 12px;
  }
`;


function MeetTeam() {
  const theme = useTheme();
  const { data: item = [] } = useSWR(
    `aboutUsTeamSection`,
    async () => {
      try {
        const { data } = await getAboutUsTeamSectionByPartner();
        return data?.data || [];
      } catch (error) {
        console.error("error: ", error);
        alert(error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const { data: paragraph } = useSWR(
    `aboutUsTeamParagraph`,
    async () => {
      try {
        const { data } = await getAboutUsTeamParagraphByPartner();
        return data?.data?.[0] || [];
      } catch (error) {
        console.error("error: ", error);
        alert(error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const { width } = useWindowDimensions();
  let sp = 1;
  if (width > 1350) {
    sp = 3;
  }
  if (width > 1100 && width < 1350) {
    sp = 3;
  }
  if (width > 650 && width < 1099) {
    sp = 2;
  }

  const items = [...item];
  const repeatedItems = [...items, ...items, ...items];

  return (
    <div className="TeamWrapper">
      <Box sx={{color : `${theme.palette.text.main}`}} className="TeamHeader">
        Meet the <Box component="span" sx={{color : `${theme.palette.primary.main}`}}>Team</Box>
      </Box>
      <div className="TeamBody">
        <p>{paragraph?.paragraph}</p>
      </div>
      <Swiper
        className="ImgSlideShow"
        style={{ width: "100%" }}
        slidesPerView={sp}
        spaceBetween={1}
        slidesPerGroup={1}
        loop={false}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
      >
        {repeatedItems?.map((items, index) => (
          <SwiperSlide className="Slide-component" key={index}>
            <ImgComponent theme={theme}>
              <ImgSrc src={items?.image} alt="meetteam" />
              <div className="img-text">
                {items?.name && <h4>{items?.name}</h4>}
                {items?.owner && (
                  <p>
                    {items?.owner} <br /> {items?.position}
                  </p>
                )}
              </div>
            </ImgComponent>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default MeetTeam;
